import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { axisMaxLogo, Yes_Bank,Tmb_Bank } from './../../images/images';
import './Header.css';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showLogo: false
        }
    }

    componentDidMount() {
        document.addEventListener('yesBank', this.showYesBankLogo)
    }

    showYesBankLogo = () => {
        this.setState({ showLogo: true })
    }

    render() {
        return (
            <>
                <div className='head-bar'>
                    <AppBar className="appbar">
                        <Toolbar className="header">
                            <img src={axisMaxLogo} alt="Logo" height="32px" />
                            {
                                this.state.showLogo ? <div className='vertical-line'></div> : null
                            }

                            {
                                this.state.showLogo ? <img src={Yes_Bank} alt="Logo" height="32px" className='yes-bank-logo' /> : null
                            }
                        </Toolbar>
                    </AppBar>
                    <LinearProgress style={{ visibility: this.props.showLoader ? 'visible' : 'hidden' }} />
                </div>
            </>
        )
    }
}

const mapStateToProps = ({ showLoader }) => {
    return { showLoader }
}

export default connect(mapStateToProps)(Header);